import { useSplitTreatment } from './useSplitTreatment';
import {
  SPLIT_IO_FEATURE_FLAG_DESIGN_IT_FOR_ME, SPLIT_IO_FEATURE_FLAG_DESIGN_IT_FOR_ME_COOKIE
} from 'constants/split';
import { SPLIT_TRAFFIC_TYPES } from 'au-js-sdk/lib/services/split.io/constants';
import { useProduct } from '../../features/pdp';
import { SKU_LAYFLAT, SKU_PHOTO_WRAPPED_LAYFLAT, SKU_SIG_LAY, SKU_WEDDING_LAY } from 'components/constants/products';
import { SKU_EVERYDAY_PHOTO_BOOK } from 'helpers/projects/redirect';

const PRODUCTS_IN_TEST = [
  SKU_LAYFLAT,
  SKU_PHOTO_WRAPPED_LAYFLAT,
  SKU_WEDDING_LAY,
  SKU_SIG_LAY,
  SKU_EVERYDAY_PHOTO_BOOK
];

export const useShouldOpenDesignItForMeModal = (): boolean => {
  const { product } = useProduct();

  const { treatmentStatus: splitEnabled } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_DESIGN_IT_FOR_ME,
    SPLIT_IO_FEATURE_FLAG_DESIGN_IT_FOR_ME_COOKIE,
    SPLIT_TRAFFIC_TYPES.ANONYMOUS
  );

  const isRelevantProduct = PRODUCTS_IN_TEST.includes(product.sku);

  return splitEnabled && isRelevantProduct;
};
